export default __webpack_public_path__ + "static/media/168.c67d9093.svg";